module.exports = __webpack_public_path__ + "img/tnkc-banner.3c19a7ed.png";